var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"err_page"},[_c('img',{attrs:{"src":"images/404.png","alt":""}}),_c('p',{staticStyle:{"color":"#6B798E","font-size":"14px"}},[_vm._v(" 对不起，您没有足够的权限。 ")]),_c('div',{staticClass:"err_page_btn"},[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回上一页")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }